import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { chevronRight } from '@primeicons/core/chevron-right';

@Component({
    selector: 'svg[data-p-icon="chevron-right"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class ChevronRight extends CoreIcon {
    constructor() {
        super();
        this._icon = chevronRight;
    }
}
